<script lang="ts">
    import Bitmap from "./Bitmap.svelte"

    let a: HTMLAnchorElement
    export let selected: boolean
    export let bitmap: ImageBitmap
    export let tooBig: boolean
</script>

<!-- svelte-ignore a11y-invalid-attribute -->
<a
    bind:this={a}
    href="javascript:void(0)"
    role="radio"
    aria-checked={selected}
    on:click|preventDefault
    class="w-32 h-32 aria-checked:outline-4 relative outline-0 transition-all rounded-lg overflow-hidden flex-grow flex-shrink-0"
>
    <Bitmap {bitmap} class={`w-full h-full ${tooBig ? "opacity-20" : ""}`} />
    <div
        class="w-full h-full absolute left-0 top-0 flex flex-col p-3 text-center items-center justify-center"
    >
        {#if tooBig}
            <!-- <Icon icon="circle-warning" class="w-8" /> -->
            <span class="text-gray-500">Too much text!</span>
        {/if}
    </div>
</a>
